<template>
  <div class>
    <v-btn v-on:click="addActive = true">Ajouter un type de mail</v-btn>
    <v-dialog v-model="addActive" max-width="980px">
      <v-card>
        <v-toolbar>
          <v-toolbar-title>Ajouter un type de mail</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="addMail.key" label="Clé" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="addMail.name" label="Nom du mail" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="addMail.subject" label="Sujet du mail" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea v-model="addMail.description" label="Description" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <mailchimp-template v-model="addMail.mandrillTemplate"></mailchimp-template>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small @click="submit()" class="primary">Sauver</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import libraries
import MailchimpTemplate from "./MailchimpTemplate";
import { mapActions } from "vuex";

export default {
  name: "addMail",
  components: {
    MailchimpTemplate
  },
  mounted() {},
  props: {
    edit: {
      type: Object
    }
  },
  watch: {
    edit: function() {
      if (this.edit) {
        this.addActive = true;
        this.addMail.key = this.edit.key;
        this.addMail.name = this.edit.name;
        this.addMail.subject = this.edit.subject;
        this.addMail.description = this.edit.description;
        this.addMail.mandrillTemplate = this.edit.mandrillTemplate;
      }
    }
  },
  data() {
    return {
      addActive: false, // si le button est activé on affichera le "form update user info"
      addMail: {
        key: "",
        name: "",
        subject: "",
        description: "",
        mandrillTemplate: ""
      },
      verificationMessage: {
        submitStatus: null,
        message: ""
      }
    };
  },
  methods: {
    ...mapActions("options", ["saveMailing", "createMailing"]),
    submit() {
      if (this.edit) {
        this.saveMailing({ id: this.edit.id, model: this.addMail }).then(() => {
          this.$emit("addMail");
          this.addActive = false;
        });
      } else {
        this.createMailing({ model: this.addMail }).then(() => {
          this.$emit("addMail");
          this.addActive = false;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
form {
  position: relative;
  max-width: 500px;
  background-color: white;
  padding: 2rem 4rem;
  border-radius: 5px;

  .form__input {
    padding: 0.5rem;
    height: 2.4rem;
    width: 100%;
    border-radius: 20px;
  }
}

.btn-orange {
  padding: 0.5rem 1.2rem;
  border-radius: 16px;
}
</style>